import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const SubSectionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '22px 24px 10px',
  borderBottom: '1px solid #E1E4E7',
  width: '100%'
});

const DisplayText = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '20px',
  color: '#2C3542',
  letterSpacing: '1px'
});

interface CommunicationSubSectionProps {
  displayText: string;
}

const CommunicationSubSectionHeader = ({ displayText }: CommunicationSubSectionProps) => {
  return (
    <SubSectionContainer>
      <DisplayText variant='body2'>
        {displayText}
      </DisplayText>
    </SubSectionContainer>
  );
};

export default CommunicationSubSectionHeader;
